module.exports = __webpack_public_path__ + "static/media/winterWhite.fc44da00.jpg";